import {
  Flex,
  NoRowsOverlay,
  BarChartIcon,
  FindInPageOutlinedIcon,
  Loading,
} from '@shared/components';

interface OnRowOverlayItemAnalysisTableProps {
  total: number;
  isLoading?: boolean;
  isFilterSet?: boolean;
}

export default function OnRowOverlayItemAnalysisTable(
  props: Readonly<OnRowOverlayItemAnalysisTableProps>,
) {
  const { total, isLoading = false, isFilterSet = false } = props;

  return (
    <>
      {total === 0 && !isLoading && !isFilterSet ? (
        <Flex
          sx={{
            py: (theme) => theme.spacing(20),
            width: '100%',
          }}
        >
          <NoRowsOverlay
            title='ยังไม่มีข้อมูลให้แสดง'
            icon={BarChartIcon}
            description='โปรดเลือกตัวกรองด้านบนก่อน เพื่อดูข้อมูลรายงานตามช่วงวันที่หรือเงื่อนไขที่ต้องการ'
            slotProps={{
              icon: {
                fontSize: 100,
              },
              wrapper: {
                disablePadding: true,
              },
            }}
          />
        </Flex>
      ) : null}
      {total === 0 && isFilterSet && !isLoading ? (
        <Flex
          sx={{
            py: (theme) => theme.spacing(20),
            width: '100%',
          }}
        >
          <NoRowsOverlay
            title='ไม่พบข้อมูลที่ตรงกับการค้นหา'
            icon={FindInPageOutlinedIcon}
            slotProps={{
              icon: {
                fontSize: 100,
              },
              wrapper: {
                disablePadding: true,
              },
            }}
          />
        </Flex>
      ) : null}
      {isLoading ? <Loading sx={{ height: '100dvh' }} /> : null}
    </>
  );
}
